"use client"

import { Button } from "@/components/ui/button"
import { AlertTriangle, Home, RefreshCw, ServerCrash, Database } from 'lucide-react'
import { useRouter } from "next/navigation"

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    const router = useRouter()

    return (
        <html lang="es" className="antialiased">
            <body className="font-sans">
                <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-gray-50">
                    <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-lg text-center">

                        <div className="relative w-40 h-40 mx-auto mb-6 flex items-center justify-center">
                            <div className="relative">
                                <ServerCrash className="h-24 w-24 text-primary-gold/30 absolute -left-3 -top-3 transform -rotate-6" />
                                <AlertTriangle className="h-16 w-16 text-primary-gold" />
                                <Database className="h-12 w-12 text-gray-300 absolute -right-6 -bottom-6 transform rotate-6" />
                            </div>
                        </div>

                        <h1 className="text-6xl font-bold text-primary-gold/20 mb-4 font-playfair">Error</h1>
                        <h2 className="text-2xl font-bold mb-4 font-playfair">Algo salió mal</h2>
                        <p className="text-gray-600 mb-6">
                            Lo sentimos, ha ocurrido un error inesperado en el servidor. Nuestro equipo ha sido notificado y estamos trabajando para solucionarlo.
                        </p>

                        <div className="flex flex-col sm:flex-row gap-4 justify-center">
                            <Button
                                onClick={reset}
                                className="flex items-center gap-2 bg-primary-gold hover:bg-primary-gold/90"
                            >
                                <RefreshCw className="h-4 w-4" />
                                Intentar nuevamente
                            </Button>

                            <Button
                                variant="outline"
                                className="flex items-center gap-2 border-primary-gold text-primary-gold hover:bg-primary-gold/10"
                                onClick={() => router.replace("/")}
                            >
                                <Home className="h-4 w-4" />
                                Volver al inicio
                            </Button>
                        </div>

                        {error.digest && <p className="mt-4 text-xs text-gray-500">ID del error: {error.digest}</p>}
                    </div>
                </div>
            </body>
        </html >
    )
}
